import { pickMime } from '../media';

const extFor = (mime) => (mime.includes('mp4') ? 'm4a' : mime.includes('ogg') ? 'ogg' : 'webm');

// Hands-free answer capture: records the mic, detects speech start, and stops after a
// short silence. `hold(true)` suspends auto-stop (e.g. while a prompt is playing).
export function captureAnswer(stream, meter, {
  onSpeechStart, onDone, onNoSpeech, silenceMs = 2600, noSpeechPromptMs = 20000, noSpeechStopMs = 75000, maxMs = 180000,
}) {
  const mime = pickMime(['audio/webm;codecs=opus', 'audio/webm', 'audio/mp4', 'audio/ogg;codecs=opus']);
  const rec = new MediaRecorder(new MediaStream(stream.getAudioTracks()), mime ? { mimeType: mime, audioBitsPerSecond: 48000 } : undefined);
  const chunks = [];
  const calib = [];
  const t0 = performance.now();
  let floor = null;
  let speechAt = null;
  let lastVoice = 0;
  let voiced = 0;
  let aborted = false;
  let held = false;
  let prompted = false;
  let timer = null;

  const stop = () => { if (rec.state !== 'inactive') rec.stop(); };
  const abort = () => {
    aborted = true;
    clearInterval(timer);
    if (rec.state !== 'inactive') rec.stop();
  };

  rec.ondataavailable = (e) => { if (e.data && e.data.size) chunks.push(e.data); };
  rec.onstop = () => {
    clearInterval(timer);
    if (aborted) return;
    const type = rec.mimeType || mime || 'audio/webm';
    onDone(new Blob(chunks, { type }), {
      speechStartedAt: speechAt, speechMs: speechAt ? Math.max(0, Math.round(lastVoice - speechAt)) : 0, ext: extFor(type),
    });
  };
  rec.start(1000);

  timer = setInterval(() => {
    const now = performance.now();
    const v = meter.read();
    if (now - t0 < 500) { calib.push(v); return; }
    if (floor === null) floor = Math.min(0.03, Math.max(0.004, Math.min(...calib)));
    const thr = Math.max(0.018, floor * 3);
    if (v > thr) {
      voiced += 50;
      lastVoice = now;
      if (!speechAt && voiced >= 200) {
        speechAt = now - voiced;
        onSpeechStart?.(speechAt);
      }
    } else if (!speechAt) {
      voiced = Math.max(0, voiced - 50);
    }
    if (held) return;
    if (speechAt && now - lastVoice > silenceMs && now - speechAt > 1500) stop();
    else if (!speechAt && !prompted && now - t0 > noSpeechPromptMs) { prompted = true; onNoSpeech?.(); }
    else if (!speechAt && now - t0 > noSpeechStopMs) stop();
    else if (now - t0 > maxMs) stop();
  }, 50);

  return { stop, abort, hold: (h) => { held = h; }, hasSpeech: () => speechAt !== null };
}
